import $ from "jquery";
/*document.querySelectorAll('ul.tabs li a').forEach(element => {
    element.addEventListener('click', function (event) {
        event.preventDefault();
        let target = this.getAttribute('href') 
        element.classList.toggle('active')
        document.querySelector(target).classList.toggle('active')
    })
})*/

// Page détail produit
/* $('.tab-pane__title a').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $('.tab-pane__title a').removeClass('active');
    $('.tab-pane__content').removeClass('active');

    $(this).addClass('active');
    $(tab_id).addClass('active');
}); */

$('ul.tabs li a').click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr('href');

    $('ul.tabs li a').removeClass('active');
    $('.tab-pane__content').removeClass('active');

    $(this).addClass('active');
    $(tab_id).addClass('active');
});

$('.tab-pane__title a').click(function() {
    var $this = $(this);
    var $parent = $this.parents('.tab-pane__content');
    var $openedBoxes = $('.tab-pane__content.active');

    if($parent.length) {
      $('.tab-pane__title a').removeClass('active');

      if($openedBoxes.length) {
        $openedBoxes.each(function(index, box) {
          if(box === $parent[0]) {
            $openedBoxes.splice(index, 1);
          }
        });
        if($openedBoxes.length) {
          $openedBoxes.removeClass('active');
        }
      }
      $parent.toggleClass('active');
    }
});
